module.exports = __webpack_public_path__ + "static/media/03.decf1311.mp3";